// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TH0f","textarea":"styles_textarea__23rKA"};